<template>
  <div id="app">
    <span style="font-size:100px">☕</span>
    <h1>{{selected.company}}</h1>
    <sub>A new coffee experience brought to you by {{selected.owner}}, with finely crafted beverages and a carefully curated menu by {{selected.barista}}.</sub>
    <br>
    <p>Every beverage created with love and care for your satisfaction; we hope that you enjoy your time at {{selected.company}}. While considering the menu, take a moment to review our current specialty. It's a limited time menu item, so be sure to order while it's available!</p>
    <h2>Signature Beverage Of The Week</h2>
    <B>{{selected.menu[0].title}}</B><br>
    <!--
    <canvas id="myCanvas"></canvas><br>
    -->
    <p>Made with {{selected.menu[0].base.roast}} {{selected.menu[0].base.bean}} beans, this drink is carefully brewed as {{selected.menu[0].base.brew}}.
      Mixed gently with <span v-for="item in selected.menu[0].adds">{{item.name}}, </span>and topped with {{selected.menu[0].top.name}}. Enjoy.</p>
    <hr width="400">
    <h2>Regular Menu Items</h2>
    <table style="margin:auto">
      <tr>
        <td>
          <ul v-for="(drink, index) in selected.menu" v-if="index > 0 && index <= 3">
            <h4>{{drink.title}}</h4>
            <li>{{drink.base.brew}}, {{drink.base.roast}} {{drink.base.bean}} beans</li>
            <li v-for="item in drink.adds">{{item.name}}</li>
            <li>Topped with {{drink.top.name}}.</li>
          </ul>
        </td>
        <td>
          <ul v-for="(drink, index) in selected.menu" v-if="index > 3">
            <h4>{{drink.title}}</h4>
            <li>{{drink.base.brew}}, {{drink.base.roast}} {{drink.base.bean}} beans</li>
            <li v-for="item in drink.adds">{{item.name}}</li>
            <li>Topped with {{drink.top.name}}.</li>
          </ul>
        </td>
      </tr>
    </table>
    <sub>This page brought to you procedurally by <a href="http://www.github.com/hectate/">Nathaniel 'Hectate' Mitchell.</a></sub>
  </div>
</template>

<script>
import paper from 'paper';

var data = {
  selected:{
    company:'Default Cafe',
    owner:'Default Owner',
    barista:'Defalt Barista',
    menu:[
    ],
    colors:{
      primary:'',
      secondary:'',
      accent:''
    }
  },
  drinks: {
    roasts: [
      'green',
      'dark',
      'mild',
      'bold',
      'raw',
      'light',
      'charred',
      'stewed',
      'candied',
      'roasted',
      'natural',
      'burnt',
      'fresh',
      'popped'
    ],
    beans: [
      'Arabica',
      'jelly',
      'Robusta',
      'Liberica',
      'Excelsa',
      'fake',
      'cocoa',
      'stinky',
      'pinto'
    ],
    brews: [
      'drip-brew coffee',
      'espresso',
      'cold-brew coffee',
      'instant coffee powder',
      'decaf coffee',
      'french pressed coffee',
      'iced coffee',
      'moka-style coffee',
      'vacuum siphoned coffee',
      'freshly brewed coffee'
    ],
    additives: [
      'sprinkles',
      'water',
      'raw egg yolk',
      'raw egg white',
      'caramel',
      'whipped cream',
      'marshmallows',
      'chocolate cream',
      'chocolate chunks',
      'chocolate syrup',
      'cherry-flavor syrup',
      'goat milk',
      'almond milk',
      'soy milk',
      'bacon bits',
      'cookie crumbles',
      'ice cream',
      'toffee bits',
      'disgusting stuff',
      'skim milk',
      'strawberrys',
      'milk',
      'creamer',
      'blueberrys',
      'peaches',
      'pocket lint',
      'fire',
      'nonsense',
      'sadness',
      'love',
      'YOUR money',
      'FREE money',
      'dirty socks',
      'sunshine',
      'ranch dressing',
      'peanut butter',
      'treenuts',
      'mold',
      'wild mushrooms',
      'wild berrys',
      'cherries',
      'peppers',
      'ghost peppers',
      'tomatos',
      'ketchup',
      'mustard',
      'watermelon',
      'toenails',
      'cucumber',
      'mango',
      'cinnamon',
      'nutmeg',
      'pumpkin pie spice',
      'eggnog',
      'almonds'
    ],
    nouns: [
      'coffee',
      'pseudo-latte',
      'darkness',
      'esspressemonte',
      'java',
      'mugly',
      'espresso',
      'frappe',
      'cappuccino',
      'macchiato',
      'irish coffee',
      'flat white',
      'americano',
      'monster brew',
      'crude oil',
      'hot chocolate-esque',
      'nothing',
      'mango coffee',
      'iced coffee',
      'milky coffee',
      'watery coffee'
      
    ],
    adjectives: [
      'darker',
      'lighter',
      'warm',
      'iced',
      'extra',
      'absolute',
      'lesser',
      'tall',
      'frumpy',
      'blue',
      'red',
      'arduous',
      'genius',
      'potent',
      'predictable',
      'stinky',
      'flaming',
      'troublesome',
      'clarified',
      'fluffy',
      'fluffed',
      'damaged',
      'frozen',
      'burning',
      'smokey',
      'furry',
      'hairy',
      'fuzzy',
      'rainbow',
      'yellow',
      'clear',
      'darkened',
      'modern',
      'old-timey',
      'ancient',
      'bizarre',
      'courageous',
      'saged',
      'wise',
      'seasoned',
      'tricky',
      'transported',
      'warped',
      'solid',
      'coffee',
      'great',
      'bad',
      'black',
      'annoying',
      'decaf',
      'blind',
      'inky',
      'terrifying',
      'speedy',
      'drowsy',
      'sweet',
      'over exagerated',
      'very very very very Expensive',
      'horrible',
      'sticky and stinky',
      'crude',
      'hot',
      'ponderous',
      'polka dot',
      'soft',
      'bright',
      'textured',
      'mysteriously glowing',
      'mysterious',
      'positivly repulsive',
      'suspicious',
      'ahhhhhh it is....',
      'spicy',
      'unwanted',
      'reused',
      'recycled',
      'trashy',
      'mango',
      'award winning',
      'complementary',
      'opposite of',
      'messed up',
      'cowardish',
      'popular'
    ],
    volumes: [
      ['tiny amount', 'dash','touch','pinch','smidge'], //size 0
      ['bit','small amount','one part'],                //size 1
      ['medium amount','two parts','dose','pour'],      //size 2
      ['large amount','three parts','heap','healthy splash'] //size 3
    ]
  },
  people: {
    first: [
      'A.','B.','C.','D.','E.','F.','G.','H.','I.','J.','K.','L.','M.','N.','O.','P.','Q.','R.','S.','T.','U.','V.','W.','X.','Y.','Z.',
      "Aaliyah",
      "Aaron",
      "Abby",
      "Abigail",
      "Abraham",
      "Adam",
      "Addison",
      "Adrian",
      "Adriana",
      "Adrianna",
      "Aidan",
      "Aiden",
      "Alan",
      "Alana",
      "Alejandro",
      "Alex",
      "Alexa",
      "Alexander",
      "Alexandra",
      "Alexandria",
      "Alexia",
      "Alexis",
      "Alicia",
      "Allison",
      "Alondra",
      "Alyssa",
      "Amanda",
      "Amber",
      "Amelia",
      "Amy",
      "Ana",
      "Andrea",
      "Andres",
      "Andrew",
      "Angel",
      "Angela",
      "Angelica",
      "Angelina",
      "Anna",
      "Anthony",
      "Antonio",
      "Ariana",
      "Arianna",
      "Ashley",
      "Ashlyn",
      "Ashton",
      "Aubrey",
      "Audrey",
      "Austin",
      "Autumn",
      "Ava",
      "Avery",
      "Ayden",
      "Bailey",
      "Benjamin",
      "Bianca",
      "Blake",
      "Braden",
      "Bradley",
      "Brady",
      "Brandon",
      "Brayden",
      "Breanna",
      "Brendan",
      "Brian",
      "Briana",
      "Brianna",
      "Brittany",
      "Brody",
      "Brooke",
      "Brooklyn",
      "Bryan",
      "Bryce",
      "Bryson",
      "Caden",
      "Caitlin",
      "Caitlyn",
      "Caleb",
      "Cameron",
      "Camila",
      "Carlos",
      "Caroline",
      "Carson",
      "Carter",
      "Cassandra",
      "Cassidy",
      "Catherine",
      "Cesar",
      "Charles",
      "Charlotte",
      "Chase",
      "Chelsea",
      "Cheyenne",
      "Chloe",
      "Christian",
      "Christina",
      "Christopher",
      "Claire",
      "Cody",
      "Colby",
      "Cole",
      "Colin",
      "Collin",
      "Colton",
      "Conner",
      "Connor",
      "Cooper",
      "Courtney",
      "Cristian",
      "Crystal",
      "Daisy",
      "Dakota",
      "Dalton",
      "Damian",
      "Daniel",
      "Daniela",
      "Danielle",
      "David",
      "Delaney",
      "Derek",
      "Destiny",
      "Devin",
      "Devon",
      "Diana",
      "Diego",
      "Dominic",
      "Donovan",
      "Dylan",
      "Edgar",
      "Eduardo",
      "Edward",
      "Edwin",
      "Eli",
      "Elias",
      "Elijah",
      "Elizabeth",
      "Ella",
      "Ellie",
      "Emily",
      "Emma",
      "Emmanuel",
      "Eric",
      "Erica",
      "Erick",
      "Erik",
      "Erin",
      "Ethan",
      "Eva",
      "Evan",
      "Evelyn",
      "Faith",
      "Fernando",
      "Francisco",
      "Gabriel",
      "Gabriela",
      "Gabriella",
      "Gabrielle",
      "Gage",
      "Garrett",
      "Gavin",
      "Genesis",
      "George",
      "Gianna",
      "Giovanni",
      "Giselle",
      "Grace",
      "Gracie",
      "Grant",
      "Gregory",
      "Hailey",
      "Haley",
      "Hannah",
      "Hayden",
      "Hector",
      "Henry",
      "Hope",
      "Hunter",
      "Ian",
      "Isaac",
      "Isabel",
      "Isabella",
      "Isabelle",
      "Isaiah",
      "Ivan",
      "Jack",
      "Jackson",
      "Jacob",
      "Jacqueline",
      "Jada",
      "Jade",
      "Jaden",
      "Jake",
      "Jalen",
      "James",
      "Jared",
      "Jasmin",
      "Jasmine",
      "Jason",
      "Javier",
      "Jayden",
      "Jayla",
      "Jazmin",
      "Jeffrey",
      "Jenna",
      "Jennifer",
      "Jeremiah",
      "Jeremy",
      "Jesse",
      "Jessica",
      "Jesus",
      "Jillian",
      "Jocelyn",
      "Joel",
      "John",
      "Johnathan",
      "Jonah",
      "Jonathan",
      "Jordan",
      "Jordyn",
      "Jorge",
      "Jose",
      "Joseph",
      "Joshua",
      "Josiah",
      "Juan",
      "Julia",
      "Julian",
      "Juliana",
      "Justin",
      "Kaden",
      "Kaitlyn",
      "Kaleb",
      "Karen",
      "Karina",
      "Kate",
      "Katelyn",
      "Katherine",
      "Kathryn",
      "Katie",
      "Kayla",
      "Kaylee",
      "Kelly",
      "Kelsey",
      "Kendall",
      "Kennedy",
      "Kenneth",
      "Kevin",
      "Kiara",
      "Kimberly",
      "Kyle",
      "Kylee",
      "Kylie",
      "Landon",
      "Laura",
      "Lauren",
      "Layla",
      "Leah",
      "Leonardo",
      "Leslie",
      "Levi",
      "Liam",
      "Liliana",
      "Lillian",
      "Lilly",
      "Lily",
      "Lindsey",
      "Logan",
      "Lucas",
      "Lucy",
      "Luis",
      "Luke",
      "Lydia",
      "Mackenzie",
      "Madeline",
      "Madelyn",
      "Madison",
      "Makayla",
      "Makenzie",
      "Malachi",
      "Manuel",
      "Marco",
      "Marcus",
      "Margaret",
      "Maria",
      "Mariah",
      "Mario",
      "Marissa",
      "Mark",
      "Martin",
      "Mary",
      "Mason",
      "Matthew",
      "Max",
      "Maxwell",
      "Maya",
      "Mckenzie",
      "Megan",
      "Melanie",
      "Melissa",
      "Mia",
      "Micah",
      "Michael",
      "Michelle",
      "Miguel",
      "Mikayla",
      "Miranda",
      "Molly",
      "Morgan",
      "Mya",
      "Naomi",
      "Natalia",
      "Natalie",
      "Nathan",
      "Nathaniel",
      "Nevaeh",
      "Nicholas",
      "Nicolas",
      "Nicole",
      "Noah",
      "Nolan",
      "Oliver",
      "Olivia",
      "Omar",
      "Oscar",
      "Owen",
      "Paige",
      "Parker",
      "Patrick",
      "Paul",
      "Payton",
      "Peter",
      "Peyton",
      "Preston",
      "Rachel",
      "Raymond",
      "Reagan",
      "Rebecca",
      "Ricardo",
      "Richard",
      "Riley",
      "Robert",
      "Ruby",
      "Ryan",
      "Rylee",
      "Sabrina",
      "Sadie",
      "Samantha",
      "Samuel",
      "Sara",
      "Sarah",
      "Savannah",
      "Sean",
      "Sebastian",
      "Serenity",
      "Sergio",
      "Seth",
      "Shane",
      "Shawn",
      "Shelby",
      "Sierra",
      "Skylar",
      "Sofia",
      "Sophia",
      "Sophie",
      "Spencer",
      "Stephanie",
      "Stephen",
      "Steven",
      "Summer",
      "Sydney",
      "Tanner",
      "Taylor",
      "Thomas",
      "Tiffany",
      "Timothy",
      "Travis",
      "Trenton",
      "Trevor",
      "Trinity",
      "Tristan",
      "Tyler",
      "Valeria",
      "Valerie",
      "Vanessa",
      "Veronica",
      "Victor",
      "Victoria",
      "Vincent",
      "Wesley",
      "William",
      "Wyatt",
      "Xavier",
      "Zachary",
      "Zoe",
      "Zoey"
    ],
    last: [
      "Smith",
      "Johnson",
      "Williams",
      "Brown",
      "Jones",
      "Miller",
      "Davis",
      "Garcia",
      "Rodriguez",
      "Wilson",
      "Martinez",
      "Anderson",
      "Taylor",
      "Thomas",
      "Hernandez",
      "Moore",
      "Martin",
      "Jackson",
      "Thompson",
      "White",
      "Lopez",
      "Lee",
      "Gonzalez",
      "Harris",
      "Clark",
      "Lewis",
      "Robinson",
      "Walker",
      "Perez",
      "Hall",
      "Young",
      "Allen",
      "Sanchez",
      "Wright",
      "King",
      "Scott",
      "Green",
      "Baker",
      "Adams",
      "Nelson",
      "Hill",
      "Ramirez",
      "Campbell",
      "Mitchell",
      "Roberts",
      "Carter",
      "Phillips",
      "Evans",
      "Turner",
      "Torres",
      "Parker",
      "Collins",
      "Edwards",
      "Stewart",
      "Flores",
      "Morris",
      "Nguyen",
      "Murphy",
      "Rivera",
      "Cook",
      "Rogers",
      "Morgan",
      "Peterson",
      "Cooper",
      "Reed",
      "Bailey",
      "Bell",
      "Gomez",
      "Kelly",
      "Howard",
      "Ward",
      "Cox",
      "Diaz",
      "Richardson",
      "Wood",
      "Watson",
      "Brooks",
      "Bennett",
      "Gray",
      "James",
      "Reyes",
      "Cruz",
      "Hughes",
      "Price",
      "Myers",
      "Long",
      "Foster",
      "Sanders",
      "Ross",
      "Morales",
      "Powell",
      "Sullivan",
      "Russell",
      "Ortiz",
      "Jenkins",
      "Gutierrez",
      "Perry",
      "Butler",
      "Barnes",
      "Fisher",
      "Henderson",
      "Coleman",
      "Simmons",
      "Patterson",
      "Jordan",
      "Reynolds",
      "Hamilton",
      "Graham",
      "Kim",
      "Gonzales",
      "Alexander",
      "Ramos",
      "Wallace",
      "Griffin",
      "West",
      "Cole",
      "Hayes",
      "Chavez",
      "Gibson",
      "Bryant",
      "Ellis",
      "Stevens",
      "Murray",
      "Ford",
      "Marshall",
      "Owens",
      "Mcdonald",
      "Harrison",
      "Ruiz",
      "Kennedy",
      "Wells",
      "Alvarez",
      "Woods",
      "Mendoza",
      "Castillo",
      "Olson",
      "Webb",
      "Washington",
      "Tucker",
      "Freeman",
      "Burns",
      "Henry",
      "Vasquez",
      "Snyder",
      "Simpson",
      "Crawford",
      "Jimenez",
      "Porter",
      "Mason",
      "Shaw",
      "Gordon",
      "Wagner",
      "Hunter",
      "Romero",
      "Hicks",
      "Dixon",
      "Hunt",
      "Palmer",
      "Robertson",
      "Black",
      "Holmes",
      "Stone",
      "Meyer",
      "Boyd",
      "Mills",
      "Warren",
      "Fox",
      "Rose",
      "Rice",
      "Moreno",
      "Schmidt",
      "Patel",
      "Ferguson",
      "Nichols",
      "Herrera",
      "Medina",
      "Ryan",
      "Fernandez",
      "Weaver",
      "Daniels",
      "Stephens",
      "Gardner",
      "Payne",
      "Kelley",
      "Dunn",
      "Pierce",
      "Arnold",
      "Tran",
      "Spencer",
      "Peters",
      "Hawkins",
      "Grant",
      "Hansen",
      "Castro",
      "Hoffman",
      "Hart",
      "Elliott",
      "Cunningham",
      "Knight",
      "Bradley"
    ]
  },
  company: {
    adjectives:[
      'Hipster',
      'Happy',
      'Sad',
      'Troublesome',
      'Awesome',
      'Caffeinated',
      'Stressed',
      'Hot',
      'Excited',
      'Loud',
      'Joyful',
      'Hairy',
      'Handsome',
      'Beautiful',
      'Urban',
      'Smelly',
      'Slippery',
      'Warty',
      'Old',
      'Pitiful'
    ],
    nouns:[
      'Hipster',
      'Hedgehog',
      'Porker',
      'Egg',
      'Cafe',
      'Cup',
      'Spot',
      'Joint',
      'Alphabet',
      'Box',
      'Falcon',
      'Eel',
      'Cube',
      'Fish',
      'Bear',
      'Hog',
      'Wart',
      'Witch',
      'Wizard',
      'Broomstick',
      'Frog',
      'Owl',
      'Snake',
      'Book',
      'Paper',
      'Tome',
      'Speaker',
      'Singer',
      'Plate',
      'Bowl'
    ]
  }
};

export default {
  name: 'app',
  components: {
  },
  data: function () {
    return data;
  },
  created: function() {
    this.selected.company = generateCompany();
    this.selected.owner = generatePerson();
    this.selected.barista = generatePerson();
    //this.selected.menu.push(generateBeverage());
    for(var i=0; i < 7; i++) {
      this.selected.menu.push(generateBeverage());
    }
  },
  mounted: function() {
    var canvas = document.getElementById('myCanvas');
    paper.setup(canvas);
    var path = new paper.Path();
    path.strokeColor = 'black';
    var start = new paper.Point(100,100);
    path.moveTo(start);
    path.lineTo(start.add([ 200, -50]));
    paper.view.draw();

  }
}

function generateBeverage() {
  var result = {
    base:{
      volume:0,
      volumeText:'',
      roast:'',
      bean:'',
      brew:'',
    },
    adds:[/*
      {
        volume:0,
        volumeText:'',
        name:' Default'
      }
      */
    ],
    top:{
      name:''
    },
    title: ''
  };
  let vol = randomIndex(3)+1;
  result.base.volume = vol;
  result.base.volumeText = randomItem(data.drinks.volumes[vol]);
  result.base.roast = randomItem(data.drinks.roasts);
  result.base.bean = randomItem(data.drinks.beans);
  result.base.brew = randomItem(data.drinks.brews);
  //pick 1-3 additives, and then 1 topping, both from the same list of additives
  for (var i=0; i < randomIndex(3)+1; i++) {
    result.adds.push(
      {
        volume:0,
        volumeText:'',
        name: randomItem(data.drinks.additives)
      }
    )
  }
  result.top.name = randomItem(data.drinks.additives);
  let title = randomItem(data.drinks.adjectives) + ' ' + randomItem(data.drinks.nouns); //todo, get more creative with coffee names
  result.title = title.toUpperCase();
  return result;
}

function randomItem(array) {
  return array[randomIndex(array.length)];
}

function generatePerson() {
  var result = '';
  result = randomItem(data.people.first) + ' ' + randomItem(data.people.last);
  return result;
}

function generateCompany() {
  var result = '';
  result = 'The ' + randomItem(data.company.adjectives) + ' ' + randomItem(data.company.nouns);
  return result;
}

function randomIndex(length) {
  var index = Math.floor(Math.random() * length);
  return index;
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
